
  import { mapGetters } from 'vuex'
  import DataTable from '@/mixins/dataTable'
  import playerProfile from '~/mixins/common/pages/player-profile'
  export default {
    mixins: [DataTable, playerProfile],
    data() {
      return {
        tab: null,
        api: 'themes/refer-friend/getReferFriend',
        claimLoading: false
      }
    },
    computed: {
      ...mapGetters({
        referFriend: 'themes/refer-friend/referFriend'
      }),
      headers() {
        return [
          { text: this.tl('claimDateTime'), value: 'claim_time' },
          { text: this.tl('numberOfFriends'), value: 'number_of_friend' },
          { text: this.tl('referralRate'), value: 'max_percentage' },
          { text: this.tl('commission'), value: 'commission' },
          { text: this.tl('status'), value: 'status', sortable: false }
        ]
      },
      pageFriendSummary() {
        let sum = 0
        for (const refer of this.referFriend?.data) {
          if (isNaN(refer.number_of_friend)) continue
          sum += Number.parseInt(refer.number_of_friend)
        }
        return sum
      },
      pageCommissionSummary() {
        let sum = 0
        for (const refer of this.referFriend?.data) {
          if (isNaN(refer.commission)) continue
          sum += Number.parseFloat(refer.commission)
        }
        return sum
      }
    },
    mounted() {
      this.customFilters = {
        language: this.handleCookie('wl_locale'),
        start_date: this.$dayjs().format('YYYY-MM-DD'),
        end_date: this.$dayjs().format('YYYY-MM-DD')
      }
    },
    beforeDestroy() {
      this.doCancelAxiosRequest()
    },
    methods: {
      doSubmitSearch() {
        this.API()
      },
      async claimCommission() {
        this.claimLoading = true
        const result = await this.$store.dispatch('themes/refer-friend/doClaimCommission')
        if (result) {
          await this.$store.dispatch('player/profile')
          this.API()
        }
        this.claimLoading = false
      },
      updateStartDate(date) {
        this.customFilters.start_date = date
      },
      updateEndDate(date) {
        this.customFilters.end_date = date
      }
    }
  }
